import React, { useState, useEffect } from "react";
import { Container, Table, Button, Form } from "react-bootstrap";
import { serverData } from "./onServer";

const PRICES_DATA_ID = "prices";

const PriceListPage = ({ isAdmin }) => {

    const initialServerData = serverData(PRICES_DATA_ID);

    const [categories, setCategories] = useState(() => {
        return initialServerData || [];
    });

    const fetchFromServer = () => {
        fetch("/priceList", {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        }).then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            return response.json();
        }).then(data => setCategories(data))
            .catch(error => console.error('Error:', error));
    };

    // componentDidMount effect
    useEffect(() => {
        if (initialServerData === undefined) {
            fetchFromServer();
        }
    }, [initialServerData]);


    const updateProduct = (catIdx, prodIdx, updatedProduct) => {
        const updated = [...categories];
        updated[catIdx].items[prodIdx] = updatedProduct;
        setCategories(updated);
    };

    const [newCategoryTitle, setNewCategoryTitle] = useState("");


    const renderAddCategory = () => {
        return (
            <>
                <h5 className="mt-4">Přidat novou kategorii</h5>
                <Form
                    className="d-flex gap-2 mb-4"
                    onSubmit={(e) => {
                        e.preventDefault();
                        if (!newCategoryTitle.trim()) return;
                        setCategories([
                            ...categories,
                            { title: newCategoryTitle.trim(), items: [] }
                        ]);
                        setNewCategoryTitle("");
                    }}
                >
                    <Form.Control
                        size="sm"
                        placeholder="Jméno kategorie (např.: Koláče)"
                        value={newCategoryTitle}
                        onChange={(e) => setNewCategoryTitle(e.target.value)}
                    />
                    <Button size="sm" type="submit" variant="primary">
                        Přidat kategorii
                    </Button>
                </Form>
            </>
        );
    };

    const renderAddSize = (catIdx, itemIdx, item) => {
        return (
            <tr>
                <td colSpan={4} style={{ padding: "10px" }}>
                    <Button
                        size="sm"
                        variant="success"
                        onClick={() => {
                            const updated = { ...item };
                            updated.sizes.push({
                                size: "Popis varianty (volitelné)",
                                price: "",
                                minOrder: ""
                            });
                            updateProduct(catIdx, itemIdx, updated);
                        }}
                    >
                        + Přidat variantu
                    </Button>
                </td>
            </tr>
        );
    };

    return (
        <Container>
            <h1 className='display-5 text-center'>Ceník</h1>
            <div className="text-center display-6">(platný od 1.7.2026)</div>
            {categories && categories.map((cat, catIdx) => (
                <div key={catIdx} className="mb-4">
                    <h3 className="border-bottom pb-1">{cat.title}</h3>
                    <Table striped bordered size="sm" className="mt-2">
                        <thead>
                            <tr>
                                <th>Produkt</th>
                                <th>Cena</th>
                                <th>Min. Odběr*</th>
                                {isAdmin && <th>Akce</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {cat.items.map((item, itemIdx) => {
                                return (
                                    item.sizes.map((variant, variantIdx) => {
                                        return (
                                            <React.Fragment key={`${itemIdx}-${variantIdx}`}>
                                                <tr>
                                                    <td>
                                                        {variantIdx === 0 && (
                                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                                {isAdmin ? (
                                                                    <Form.Control
                                                                        size="sm"
                                                                        type="text"
                                                                        value={item.name}
                                                                        onChange={(e) => {
                                                                            const updated = { ...item };
                                                                            updated.name = e.target.value;
                                                                            updateProduct(catIdx, itemIdx, updated);
                                                                        }}
                                                                        className="mb-1"
                                                                    />
                                                                ) : (
                                                                    <strong>{item.name}</strong>
                                                                )}
                                                                {isAdmin ? (
                                                                    <Form.Control
                                                                        size="sm"
                                                                        type="text"
                                                                        value={item.info || ""}
                                                                        onChange={(e) => {
                                                                            const updated = { ...item };
                                                                            updated.info = e.target.value;
                                                                            updateProduct(catIdx, itemIdx, updated);
                                                                        }}
                                                                        placeholder="Další informace (volitelné)"
                                                                    />
                                                                ) : (
                                                                    item.info && (
                                                                        <div style={{ fontSize: "0.85em", color: "#555" }}>{item.info}</div>
                                                                    )
                                                                )}
                                                            </div>
                                                        )}
                                                        {variantIdx > 0 && <span className="invisible">-</span>}
                                                        <div style={{ fontSize: "0.9em", color: "#333" }}>
                                                            {isAdmin ? (
                                                                <Form.Control
                                                                    size="sm"
                                                                    type="text"
                                                                    placeholder="Popis varianty (volitelné)"
                                                                    value={variant.size}
                                                                    onChange={(e) => {
                                                                        const updated = { ...item };
                                                                        updated.sizes[variantIdx].size = e.target.value;
                                                                        updateProduct(catIdx, itemIdx, updated);
                                                                    }}
                                                                />
                                                            ) : (
                                                                variant.size
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td className="align-bottom">
                                                        {isAdmin ? (
                                                            <Form.Control
                                                                size="sm"
                                                                type="text"
                                                                value={variant.price}
                                                                onChange={(e) => {
                                                                    const updated = { ...item };
                                                                    updated.sizes[variantIdx].price = e.target.value;
                                                                    updateProduct(catIdx, itemIdx, updated);
                                                                }}
                                                            />
                                                        ) : (
                                                            variant.price
                                                        )}
                                                    </td>
                                                    <td className="align-bottom">
                                                        {isAdmin ? (
                                                            <Form.Control
                                                                size="sm"
                                                                type="text"
                                                                value={variant.minOrder}
                                                                onChange={(e) => {
                                                                    const updated = { ...item };
                                                                    updated.sizes[variantIdx].minOrder = e.target.value;
                                                                    updateProduct(catIdx, itemIdx, updated);
                                                                }}
                                                            />
                                                        ) : (
                                                            variant.minOrder
                                                        )}
                                                    </td>
                                                    {isAdmin && (
                                                        <td>
                                                            <Button
                                                                size="sm"
                                                                variant="danger"
                                                                onClick={() => {
                                                                    const updated = { ...item };
                                                                    updated.sizes.splice(variantIdx, 1);
                                                                    updateProduct(catIdx, itemIdx, updated);
                                                                }}
                                                            >
                                                                ×
                                                            </Button>
                                                        </td>
                                                    )}
                                                </tr>
                                                {isAdmin && variantIdx === item.sizes.length - 1 && renderAddSize(catIdx, itemIdx, item)}
                                            </React.Fragment>
                                        );
                                    })
                                );
                            }
                            )}

                        </tbody>
                    </Table>
                    {isAdmin && (
                        <Button
                            size="sm"
                            variant="success"
                            onClick={() => {
                                const updated = [...categories];
                                updated[catIdx].items.push({
                                    name: "Nový produkt",
                                    info: "",
                                    sizes: [
                                        { size: "Popis varianty (volitelné)", price: "1,-", minOrder: "1" }
                                    ]
                                });
                                setCategories(updated);
                            }}
                        >
                            + Přidat produkt
                        </Button>
                    )}
                </div>
            ))}
            {isAdmin && renderAddCategory()}
            <p style={{ fontStyle: "oblique" }}>* Minimální odběr závisí vždy na domluvě, pokud mám více objednávek, je možno se domluvit i na menším množství </p>
        </Container>
    );

};

export default PriceListPage;